import React from 'react';
import store from './store';
import Router from './Router';
import PropTypes from 'prop-types';
import ScrollToTop from './ScrollToTop';
import GlobalStyles from './globalStyles';
import RechartStyles from './rechartStyles';
import 'bootstrap/dist/css/bootstrap.min.css';
import CalendarStyles from './calendarStyles';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { createTheme } from '@mui/material/styles';
import { Provider, useSelector } from 'react-redux';
import NotificationStyles from './notificationStyles';
import { auth } from '../../redux/actions/authActions';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import TimepickerStyles from '@/shared/components/form/date-pickers/timepickerStyles';

const ThemeComponent = ({
  children,
}) => {
  const {
    mode, direction, shadow, border,
  } = useSelector(state => ({
    mode: state.theme.className,
    direction: state.rtl.direction,
    shadow: state.shadow.className,
    border: state.border.className,
  }));

  const theme = createTheme({
    palette: {
      type: mode,
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <ThemeProvider
        theme={{
          mode,
          direction,
          shadow,
          border,
        }}
      >
        <GlobalStyles />
        <NotificationStyles />
        <RechartStyles />
        <TimepickerStyles />
        <CalendarStyles />
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

ThemeComponent.propTypes = {
  children: PropTypes.node.isRequired,
};

const ConnectedThemeComponent = ThemeComponent;

const App = (props) => {
  store.dispatch(auth({
    name: props.user.name,
    avatar: props.user.picture,
  }));

  return (
    <Provider store={store}>
      <BrowserRouter basename="/admin">
        <ConnectedThemeComponent>
          <ScrollToTop>
            <Router />
          </ScrollToTop>
        </ConnectedThemeComponent>
      </BrowserRouter>
    </Provider>
  );
};

export default App;